/**
 * Load interactive map over sweden used to show statistics
 */
import $ from 'jquery';
import * as d3 from 'd3';
import Popper from 'popper.js';

export default class D3Sweden {
  init() {
    let closeTimeout = null;
    const popoverFadeTime = 300;
    const provinceDataPath = '/wp-json/d3/v1/provinces/sweden';
    const mapSelector = '#map-member-region';
    const infoSelector = `${mapSelector}-info`;

    const map = $(mapSelector);
    const mapInfo = $(infoSelector);

    if (!map.length) {
      return;
    }

    const width  = 345;
    const height = 792;

    const popover = $('<div />')
        .attr('id', `map-member-region-popper`)
        .addClass('salesforce-statistics-map-popper')
        .addClass('popper');

    $('body').append(popover);
    popover.hide();

    const initPopper = elm => {
      if (!$(elm).data('popper')) {
        const popper = new Popper(elm, popover, {
          placement: 'top',
          removeOnDestroy: true,
        });
        $(elm).data('popper', popper);
      }
      return $(elm).data('popper');
    };

    const colors =['#004fa3', '#004fa3', '#004fa3', '#004fa3', '#004fa3'];
    const fillColor = d => colors[d.properties.color];

    const handleClick = (d, i, elms) => {
      clearTimeout(closeTimeout);

      const id = d.properties.l_id;
      const elm = elms[i];

      const popper = initPopper(elm);

      $(`#map-member-region-popper`)
        .html(mapInfo.find(`> div[data-province-id="${id}"]`).eq(0).html());

      popper.scheduleUpdate();
      $(popper.popper).fadeIn(popoverFadeTime);
    };

    const handleMouseOut = (d, i, elms) => {
      clearTimeout(closeTimeout);

      const elm = elms[i];
      const popper = initPopper(elm);

      closeTimeout = setTimeout(() => {
        $(popper.popper).fadeOut(popoverFadeTime);
      }, popoverFadeTime);
    };

    const mapSvg = d3
      .select(mapSelector)
      .append('svg')
      .attr('viewBox', '0 0 345 792');

    const mapSvgGroup = mapSvg.append('g');

    d3.json(provinceDataPath, function(error, data) {
      if (error) {
        console.error(error);
      }

      // Center map
      const projection = d3.geoMercator().fitSize([width, height], data);
      const path = d3.geoPath().projection(projection);

      mapSvgGroup
        .selectAll('path')
        .data(data.features)
        .enter()
        .append('path')
        .attr('d', path)
        .attr('fill', fillColor)
        .attr('stroke', 'white')
        .attr('stroke-width', 1)
        .on('click', handleClick)
        .on('mouseover', handleClick)
        .on('mouseout', handleMouseOut);
    });
  }
}
